module.exports = __webpack_public_path__ + "static/media/octopus_instruct.6bb28f94.png";